import axios from 'axios';

export interface Regua {
  id: string;
  tenant_id: string;
  nome: string;
  /** Evento de domínio que dispara a régua: `entidade.evento`. */
  gatilho: string;
  mensagem_template: string;
  ativa: boolean;
  configuracoes: Record<string, any>;
  created_at: string;
  updated_at: string;
}

/**
 * O gatilho que o servidor dispara ao concluir uma solicitação
 * (`solicitacoes.service.ts`, `triggerFeedbackRegua`).
 *
 * Mora aqui, junto da lista de gatilhos suportados, porque é vocabulário de
 * domínio COMPARTILHADO com o servidor — não constante de apresentação de uma
 * tela. Quem precisa do literal (a tela de Solicitações, para saber se a régua
 * de conclusão está ligada) importa daqui em vez de redeclarar: duas cópias
 * divergem na primeira vez que o evento for renomeado, e a tela passaria a
 * procurar uma régua que não existe mais — em silêncio, sem erro nenhum.
 */
export const GATILHO_SOLICITACAO_CONCLUIDA = 'solicitacao.concluida';

/** Gatilhos que o backend efetivamente dispara hoje. */
export const GATILHOS_SUPORTADOS = [
  { v: 'contato.aniversario', l: 'Aniversário do contato' },
  { v: GATILHO_SOLICITACAO_CONCLUIDA, l: 'Solicitação concluída' },
];

const API_URL = import.meta.env.VITE_API_URL || '/api';
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const reguasApi = {
  list: async (token: string) => {
    const res = await axios.get<Regua[]>(`${API_URL}/gab/reguas`, auth(token));
    return res.data;
  },

  create: async (
    data: { nome: string; gatilho: string; mensagem_template: string; ativa?: boolean },
    token: string,
  ) => {
    const res = await axios.post<Regua>(`${API_URL}/gab/reguas`, data, auth(token));
    return res.data;
  },

  update: async (id: string, data: Partial<Regua>, token: string) => {
    const res = await axios.put<Regua>(`${API_URL}/gab/reguas/${id}`, data, auth(token));
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/gab/reguas/${id}`, auth(token));
  },
};
